import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IKontaktDetailViewModel } from '@shared/models/kontakt-detail.model';
import { AjaxService } from 'AjaxService';


@Component({
    selector: 'cz-kontakt',
    templateUrl: 'kontakt.component.html',
    styleUrls: ['kontakt.component.css'],
    standalone: false
})
export class KontaktComponent {

  kontaktEdit: boolean = false;
  showModal: boolean;
  private _kontakte: IKontaktDetailViewModel[];
  kontaktToEdit: IKontaktDetailViewModel;

  @Output() onEmailSended: EventEmitter<any> = new EventEmitter<any>();

  @Input() canAdd: boolean = false;
  @Input() class: string = 'col-md-12 col-sm-12';
  @Input() entityArt: string;
  @Input() ownerId: number;
  @Input()
  set kontakte(value: IKontaktDetailViewModel[]) {
    this._kontakte = value;
    for (let i = 0; i < this._kontakte.length; i++) {
      this._kontakte[i].sortIndex = i;
    }
  }
  get kontakte(): IKontaktDetailViewModel[] {
    return this._kontakte;
  }

  constructor(private ajaxService: AjaxService) {
  }

  handleKontaktHasChanged(kontakt: IKontaktDetailViewModel) {
    this.ajaxService.post<IKontaktDetailViewModel[]>('api/Kontakte/SaveKontakte', { ownerId: this.ownerId, entityArt: this.entityArt, kontakte: [kontakt] }).subscribe((response) => {
      this.kontakte = response;
      this.showModal = false;
    });
  }

  handleKontaktModalClose() {
    this.showModal = false;
    this.kontaktToEdit = undefined;
  }

  handleKontaktRemove(kontakt: IKontaktDetailViewModel) {
    if (kontakt.isNew) {
      this.kontakte = this.kontakte.filter(x => x.id !== kontakt.id);
      for (let i = 0; i < this.kontakte.length; i++) {
        this.kontakte[i].sortIndex = i;
      }
    }
    else {
      this.ajaxService.post<IKontaktDetailViewModel[]>('api/Kontakte/DeleteKontakte', { ownerId: this.ownerId, entityArt: this.entityArt, kontakte: [kontakt] }).subscribe((response) => {
        this.kontakte = response;
      });
    }
  }

  onKontaktEdit(kontakt: IKontaktDetailViewModel) {
    this.kontaktToEdit = kontakt;
    this.showModal = true;
  }

  onClickAddKontakt() {
    // let biggestIndex = Math.max.apply(Math, this.kontakte.map((o) => { return o.sortIndex; })) + 1;
    let biggestIndex = Math.max(...this.kontakte.map((o) => { return o.sortIndex; })) + 1;

    biggestIndex = biggestIndex < 0 ? 0 : biggestIndex > 9999 ? 9999 : biggestIndex;
    this.kontaktToEdit = { isNew: true, ownerId: this.ownerId, sortIndex: biggestIndex } as IKontaktDetailViewModel;
    this.showModal = true;
  }

  onEmailSendFinished() {
    this.onEmailSended.emit(null);
  }

  //----

  onDragStart(e) {
    e.itemData = this.kontakte[e.fromIndex];
  }

  onReorder(e) {
    this.kontakte.splice(e.fromIndex, 1);
    this.kontakte.splice(e.toIndex, 0, e.itemData);

    for (let i = 0; i < this.kontakte.length; i++) {
      this.kontakte[i].sortIndex = i;
    }
    this.ajaxService.post<IKontaktDetailViewModel[]>('api/Kontakte/SaveKontakte', { ownerId: this.ownerId, entityArt: this.entityArt, kontakte: this.kontakte }).subscribe((response) => {
      this.kontakte = response;
    });
  }
}
